import gql from 'graphql-tag';

export default gql`
query GetAllSlugsOfAllGroups {
  groups {
    slug
  }
}
`;
